import React from 'react'
import {
  Grid,
  Typography,
  Link as MuiLink,
  useMediaQuery,
  useTheme,
  Box,
  Container,
  Divider,
} from '@mui/material'
import { Link } from 'react-router-dom'
import JSONDATA from '../Assets/JSON/MV.json'
import logo_name1 from '../Assets/Logo/logo.svg'

const Footer = () => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const isTablet = useMediaQuery(theme.breakpoints.between('sm', 'md'))

  return (
    <Box
      component="footer"
      sx={{
        backgroundColor: theme.palette.background.paper,
        color: theme.palette.text.primary,
        py: 4,
        borderTop: `1px solid ${theme.palette.divider}`,
      }}
    >
      <Container maxWidth="lg">
        <Grid container spacing={4}>
          {/* Logo Section - Full width on mobile, then first column */}
          <Grid item xs={12} md={4}>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: isMobile ? 'center' : 'flex-start',
                mb: 2,
              }}
            >
              <Box
                component="img"
                src={logo_name1}
                sx={{
                  height: 'auto',
                  width: isMobile ? '80%' : '16rem',
                  maxWidth: '100%',
                  mb: 2,
                }}
                alt="Brand Name"
              />

              <Typography
                variant="body1"
                component="p"
                sx={{
                  fontWeight: 'bold',
                  textAlign: 'left',
                  mb: 1,
                }}
              >
                DOST:11076
              </Typography>

              <Typography
                variant="body2"
                component="p"
                sx={{
                  textAlign: 'left',
                  fontSize: '0.875rem',
                  lineHeight: 1.6,
                }}
              >
                Dr. BR Ambedkar Educational Institutions
                <br />
                AP Housing Board, Baghlingampally,
                <br />
                New Nallakunta, Hyderabad,
                <br />
                Telangana-500044.
              </Typography>

              <Box sx={{ mt: 2, textAlign: 'left' }}>
                <Typography variant="body2" sx={{ mb: 0.5 }}>
                  Email:{' '}
                  <MuiLink
                    href="mailto:helpdesk@dbraei.edu.in"
                    color="inherit"
                    underline="hover"
                  >
                    helpdesk@dbraei.edu.in
                  </MuiLink>
                </Typography>
                <Typography variant="body2">
                  Contact:{' '}
                  <MuiLink
                    href="tel:040-27670675"
                    color="inherit"
                    underline="hover"
                  >
                    040 – 2767 06 75
                  </MuiLink>{' '}
                  /{' '}
                  <MuiLink
                    href="tel:+919100221282"
                    color="inherit"
                    underline="hover"
                  >
                    +91 9100221282
                  </MuiLink>
                </Typography>
              </Box>
            </Box>
          </Grid>

          {/* Courses Section */}
          <Grid item xs={12} sm={6} md={4}>
            <Box>
              <Typography
                variant="h6"
                component="h3"
                sx={{
                  fontWeight: 600,
                  mb: 2,
                  fontSize: isMobile ? '1.1rem' : '1.25rem',
                  textAlign: isMobile ? 'center' : 'left',
                }}
              >
                Our Courses
              </Typography>

              <Grid container spacing={2}>
                {/* UG Courses */}
                <Grid item xs={6}>
                  <Typography
                    variant="h6"
                    sx={{
                      mb: 1,
                      fontWeight: 500,
                      color: theme.palette.text.primary,
                      textAlign: isMobile ? 'center' : 'left',
                    }}
                  >
                    UG Courses
                  </Typography>
                  <Box
                    component="ul"
                    sx={{
                      m: 0,
                      p: 0,
                      listStyle: 'none',
                      textAlign: isMobile ? 'center' : 'left',
                    }}
                  >
                    {JSONDATA?.degree_courses.map((items, index) => (
                      <Box
                        component="li"
                        key={index}
                        sx={{
                          mb: 1,
                          fontSize: '0.875rem',
                        }}
                      >
                        {items.title}
                      </Box>
                    ))}
                  </Box>
                </Grid>

                {/* PG Courses */}
                <Grid item xs={6}>
                  <Typography
                    variant="h6"
                    // sx={{
                    //   mb: 1,
                    //   fontWeight: 500,
                    //   textAlign: isMobile ? 'center' : 'left',
                    //   color: theme.palette.text.primary,
                    // }}
                  >
                    PG Courses
                  </Typography>
                  <Box
                    component="ul"
                    sx={{
                      m: 0,
                      p: 0,
                      listStyle: 'none',
                      textAlign: isMobile ? 'center' : 'left',
                    }}
                  >
                    {JSONDATA?.masters_courses.map((items, index) => (
                      <Box
                        component="li"
                        key={index}
                        sx={{
                          mb: 1,
                          fontSize: '0.875rem',
                        }}
                      >
                        {items.title}
                      </Box>
                    ))}
                  </Box>
                </Grid>
              </Grid>
            </Box>
          </Grid>

          {/* Quick Links */}
          <Grid item xs={12} sm={6} md={4}>
            <Box>
              <Typography
                variant="h6"
                component="h3"
                sx={{
                  fontWeight: 600,
                  mb: 2,
                  fontSize: isMobile ? '1.1rem' : '1.25rem',
                  textAlign: isMobile ? 'center' : 'left',
                }}
              >
                Quick Links
              </Typography>

              <Box
                component="ul"
                sx={{
                  m: 0,
                  p: 0,
                  listStyle: 'none',
                  textAlign: isMobile ? 'center' : 'left',
                }}
              >
                <Box
                  component="li"
                  sx={{
                    mb: 1.5,
                    '&:hover': {
                      color: theme.palette.primary.main,
                    },
                  }}
                >
                  <MuiLink
                    component={Link}
                    to="/aboutus"
                    color="inherit"
                    underline="hover"
                    sx={{
                      display: 'inline-block',
                      width: '100%',
                      fontSize: '0.875rem',
                    }}
                  >
                    About Us
                  </MuiLink>
                </Box>

                <Box
                  component="li"
                  sx={{
                    mb: 1.5,
                    '&:hover': {
                      color: theme.palette.primary.main,
                    },
                  }}
                >
                  <MuiLink
                    component={Link}
                    to="/contactus"
                    color="inherit"
                    underline="hover"
                    sx={{
                      display: 'inline-block',
                      width: '100%',
                      fontSize: '0.875rem',
                    }}
                  >
                    Contact Us
                  </MuiLink>
                </Box>

                {/* Add more links as needed */}
                <Box
                  component="li"
                  sx={{
                    mb: 1.5,
                    '&:hover': {
                      color: theme.palette.primary.main,
                    },
                  }}
                >
                  <MuiLink
                    href="#"
                    color="inherit"
                    underline="hover"
                    sx={{
                      display: 'inline-block',
                      width: '100%',
                      fontSize: '0.875rem',
                    }}
                  >
                    Privacy Policy
                  </MuiLink>
                </Box>

                <Box
                  component="li"
                  sx={{
                    mb: 1.5,
                    '&:hover': {
                      color: theme.palette.primary.main,
                    },
                  }}
                >
                  <MuiLink
                    href="#"
                    color="inherit"
                    underline="hover"
                    sx={{
                      display: 'inline-block',
                      width: '100%',
                      fontSize: '0.875rem',
                    }}
                  >
                    Terms of Service
                  </MuiLink>
                </Box>
              </Box>
            </Box>
          </Grid>
        </Grid>

        <Divider sx={{ my: 4 }} />

        {/* Copyright Section */}
        <Box sx={{ textAlign: 'center', pt: 2 }}>
          <Typography variant="body2" color="text.secondary">
            © {new Date().getFullYear()} Dr. BR Ambedkar Educational
            Institutions. All rights reserved.
          </Typography>
        </Box>
      </Container>
    </Box>
  )
}

export default Footer
